export default __webpack_public_path__ + "df7f8b05240574ea469f34e281481fab.jpg";